import React from 'react';
import FaqComponent from './FaqComponent';

function FaqPageMainContainer() {
  return (
    <main role='main' className='grid gap-12 lg:gap-24 pt-12 mb-20 px-6'>
      <FaqComponent />
    </main>
  );
}

export default FaqPageMainContainer;
